import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X, Settings, Calendar } from 'lucide-react';
import { Button, TextArea, Input } from '../shared';
import DateTimePicker from '../shared/DateTimePicker';

const CreateTermsSettingsModal = ({
 isOpen,
 onClose,
 onSave,
 settings = null,
 isLoading = false
}) => {
 const [formData, setFormData] = useState({
 last_updated: '',
 introduction: '',
 });
 const [errors, setErrors] = useState({});

 useEffect(() => {
 if (settings) {
 setFormData({
 last_updated: settings.last_updated || '',
 introduction: settings.introduction || '',
 });
 } else {
 setFormData({
 last_updated: '',
 introduction: '',
 });
 }
 setErrors({});
 }, [settings, isOpen]);

 const handleChange = (e) => {
 const { name, value } = e.target;
 setFormData(prev => ({
 ...prev,
 [name]: value
 }));

 if (errors[name]) {
 setErrors(prev => ({
 ...prev,
 [name]: ''
 }));
 }
 };

 const handleSubmit = (e) => {
 e.preventDefault();
 onSave(formData);
 };

 const handleClose = () => {
 setErrors({});
 onClose();
 };

 if (!isOpen) return null;

 return createPortal(
 <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10001] p-2 sm:p-4 overflow-y-auto">
 <div className="bg-surface rounded-lg shadow-sm max-w-2xl w-full max-h-[95vh] overflow-y-auto relative my-2 sm:my-4">
 {/* Modal Header */}
 <div className="flex items-center justify-between p-3 sm:p-4 md:p-6 border-b border-gray-200 sticky top-0 bg-surface z-10">
 <div className="flex items-center">
 <div className="flex-shrink-0 h-6 w-6 sm:h-8 sm:w-8 rounded-full bg-gradient-to-r from-ink to-neutral-900 flex items-center justify-center">
 <Settings className="h-3 w-3 sm:h-4 sm:w-4 text-white" />
 </div>
 <h3 className="ml-2 sm:ml-3 text-base sm:text-lg font-medium text-gray-900 truncate">
 Terms of Service Settings
 </h3>
 </div>
 <button
 onClick={handleClose}
 className="text-gray-400 hover:text-gray-600 p-1"
 >
 <X className="h-4 w-4 sm:h-5 sm:w-5" />
 </button>
 </div>

 {/* Form */}
 <form onSubmit={handleSubmit} className="p-3 sm:p-4 md:p-6">
 <div className="space-y-4 sm:space-y-6">
 {/* Last Updated */}
 <div>
 <label className="block text-sm font-medium text-gray-700 mb-1">
 Last Updated Date
 </label>
 <Input
 name="last_updated"
 value={formData.last_updated}
 onChange={handleChange}
 placeholder="e.g., November 2, 2025"
 error={errors.last_updated}
 />
 <p className="mt-1 text-xs text-gray-500">
 Display date when terms were last updated
 </p>
 </div>

 {/* Introduction */}
 <div>
 <label className="block text-sm font-medium text-gray-700 mb-1">
 Introduction Text
 </label>
 <TextArea
 name="introduction"
 value={formData.introduction}
 onChange={handleChange}
 placeholder="Enter introduction text that appears before the terms sections..."
 rows="4"
 error={errors.introduction}
 />
 </div>
 </div>

 {/* Modal Footer */}
 <div className="mt-6 p-3 sm:p-4 md:p-6 border-t border-gray-200 flex justify-end space-x-3 sticky bottom-0 bg-surface z-10">
 <Button
 type="button"
 variant="outline"
 onClick={handleClose}
 disabled={isLoading}
 >
 Cancel
 </Button>
 <Button
 type="submit"
 variant="primary"
 loading={isLoading}
 className="w-full sm:w-auto"
 >
 Save Settings
 </Button>
 </div>
 </form>
 </div>
 </div>,
 document.body
 );
};

export default CreateTermsSettingsModal;

